import React, { useState, useEffect } from 'react';
import {
  Unlock, Locked, Assemble
} from '@one-thd/sui-icons';
import { Typography } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { formatDateTime } from '../utils';
import { ItemDetails } from './ItemDetails';

const UNLOCK_ICON = 'Signed In';
const LOCK_ICON = 'Signed Out';

export const Item = ({
  name, date, device, index, numberOfLogsToShow
}) => {
  const formatedDateTime = formatDateTime(date);

  const showUnlockIcon = name === UNLOCK_ICON || name === 'SignIn';
  const showLockIcon = name === LOCK_ICON || name === 'SignOut';
  const showDifferentIcon = ((showUnlockIcon === false && showLockIcon === false));

  return (
    <div
      data-component="Item"
      className={classNames(
        (index < numberOfLogsToShow)
          ? 'sui-block'
          : 'sui-hidden',
        'sui-flex sui-flex-col sui-my-4'
      )}
    >
      <div className="sui-flex sui-flex-row sui-flex-1 sui-justify-between">
        <div className="sui-flex sui-flex-row sui-w-6/12 sui-gap-2">
          { showUnlockIcon && <Unlock size="regular" />}
          { showLockIcon && <Locked size="regular" />}
          { showDifferentIcon && <Assemble size="regular" />}
          <Typography variant="body-lg" weight="bold">{name}</Typography>
        </div>
        <div className="sui-flex sui-flex-row sui-w-6/12  sui-gap-2 sui-justify-end">
          <Typography variant="body-base">{formatedDateTime}</Typography>
        </div>
      </div>
      <ItemDetails device={device} />
    </div>
  );
};

Item.propTypes = {
  name: PropTypes.string,
  date: PropTypes.string,
  index: PropTypes.number,
  numberOfLogsToShow: PropTypes.number,
  device: PropTypes.shape({
    browser: PropTypes.objectOf(PropTypes.string),
    ip: PropTypes.string,
    location: PropTypes.objectOf(PropTypes.string),
    os: PropTypes.objectOf(PropTypes.string),
  })
};

Item.defaultProps = {
  name: 'Unknown',
  date: 'Unknown',
  index: 0,
  numberOfLogsToShow: 0,
  device: {
    browser: {
      type: 'Unknown'
    },
    ip: 'IP',
    location: {
      city: 'Unknown',
      country: 'Unknown',
      region: 'Unknown'
    },
    os: {
      type: 'Unknown',
      version: 'Unknown'
    },
  }
};

Item.displayName = 'AccountActivityListItem';
